import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { ProjectTemplateControllerResponse } from "@ServerTypes/projectTemplates/projectTemplates.schema";

export async function getProjectTemplatesData({ value }: any) {
  const response = await axiosWrapper.post<ProjectTemplateControllerResponse>(
    `${getBackendUrl()}/projectTemplates/projectTemplateData`,
    { value },
  );
  return response.data.result;
}
